module.exports = __webpack_public_path__ + "img/leaderBoard.f35df06f.svg";